import {app} from '../app'

const processError = (event) => {
  if (event.detail) {
    const errorData = event.detail[0]
    app.removeAllNotices()
    if (errorData.error) {
      app.notify('Error', {text: errorData.error, type: 'error'})
    } else {
      if (typeof errorData.errors === 'object') return
      app.notify('Some unrecognized error', {type: 'error'})
    }
  }
}

const beforeMount = (el) => {
  el.addEventListener('ajax:error', processError)
}

const unmounted = (el) => {
  el.removeEventListener('ajax:error', processError)
}

export default {
  beforeMount,
  unmounted
}
